import {
  FilterRequestList,
  SortRequest,
  TableSettingsRequest,
} from '@evrekadev/evreka-ui-components'
import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'services/axiosBaseQuery'
import { reportsApi } from 'services/ReportManagement/reports'
import { GenericResponse, TableRequestV2, TableResponse } from 'services/types'
import { sendExportNotification } from 'utils'

export const mrfActivityApi = createApi({
  reducerPath: 'mrfActivityApi',
  tagTypes: ['Activities'],
  baseQuery: axiosBaseQuery({
    baseUrl: `${window.envVariables.REACT_APP_BASE_URL + '/MRF/'}`,
  }),
  endpoints: (builder) => ({
    getActivityList: builder.query<TableResponse<void>, TableRequestV2<number>>({
      query: ({ client_id, ...data }) => ({
        url: `v1/activity/clients/${client_id}/list/`,
        method: 'POST',
        data,
      }),
      providesTags: ['Activities'],
    }),
    exportActivities: builder.mutation<
      GenericResponse,
      {
        clientId: number
        filters: FilterRequestList
        sort: SortRequest
        columns: TableSettingsRequest
      }
    >({
      query: ({ clientId, ...data }) => ({
        url: `v1/activity/clients/${clientId}/export/`,
        method: 'POST',
        data,
      }),
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled
          sendExportNotification(data.detail.message)
          dispatch(reportsApi.util.invalidateTags(['ExportReports']))
        } catch (error) {
          console.error('Error exporting MRF activities:', error)
        }
      },
    }),
  }),
})

export const { useGetActivityListQuery, useExportActivitiesMutation } = mrfActivityApi
